import React, { useContext, useEffect } from 'react'

export type HelmetProps = {
  title?: string
  description?: string
  favicons?: {
    ico?: string
    svg?: string
    png_192?: string
    png_512?: string
    png_apple_touch?: string
  }
}

export const HelmetContext = React.createContext<{ helmet: HelmetProps; updateHelmet: (helmet: HelmetProps) => void }>({
  helmet: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateHelmet: () => {},
})

export const useHelmet = ({ title, description, favicons }: HelmetProps) => {
  const { updateHelmet } = useContext(HelmetContext)
  useEffect(() => {
    updateHelmet({ title, description, favicons })
  }, [title, description, favicons, updateHelmet])
}
